export const userdata = [
    {
      name: 'Jan',
      "Active User": 4000,
      
    },
    {
      name: 'Feb',
      "Active User": 3000,
      
    },
    {
      name: 'Mar',
      "Active User": 5000,
     
    },
    {
      name: 'Apri',
      "Active User": 4000,
      
    },
    {
      name: 'May',
      "Active User": 3000,
      
    },
    {
      name: 'Jun',
      "Active User": 2000,
      
    },
    {
      name: 'Jul',
      "Active User": 4000,
      
    },

    {
        name: 'Aug',
        "Active User": 3000,
        
      },
      {
        name: 'Sep',
        "Active User": 4000,
        
      },

      {
        name: 'Oct',
        "Active User": 1000,
        
      },

      {
        name: 'Nov',
        "Active User": 4000,
        
      },

      {
        name: 'Dec',
        "Active User": 3000,
        
      },
      

  ];


  export const userRows = [
    {
      id: 1,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jonsnow@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 2,
      username: "John Doe",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "johndoe@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 3,
      username: "Peter Parker",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "peterparker@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 4,
      username: "Philip Snack",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "philipsnack@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 5,
      username: "Jon Spiff",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jonspiff@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 6,
      username: "Allison Rain",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "allisonrain@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 7,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jonsnow@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 8,
      username: "Jon Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "jonsnow@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 9,
      username: "Anna Keller",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "annakelle@gmail.com",
      status: "active",
      salary: "$120.00",
    },
    {
      id: 10,
      username: "Beatrice Snow",
      avatar:
        "https://images.pexels.com/photos/1152994/pexels-photo-1152994.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500",
      email: "beatricesnow@gmail.com",
      status: "active",
      salary: "$120.00",
    },
  ];

  export const productRows = [
    {
      id: 1,
      name: "Info Tech",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
      employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 2,
      name: "Customer Relations",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 3,
      name: "Human Resource",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 4,
      name: "Logistics",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 5,
      name: "Finance",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 6,
      name: "Maintainance",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 7,
      name: "Aministrative",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 8,
      name: "Account",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 9,
      name: "Marketing",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
    {
      id: 10,
      name: "Engineering",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRWHWYpIj4BsjHTP7rO-qIWItx_E5xL5TtRKQ&usqp=CAU",
        employees: 123,
      status: "active",
      basicSalary: "$120.00",
    },
  ];

  export const productData = [
    {
      name: "Jan",
      "Sales": 6000,
    },
    {
      name: "Feb",
      "Sales": 3000,
    },
    {
      name: "Mar",
      "Sales": 5000,
    },
  ];
